<template>

    <section>

        <div class="clearfix documentItem mb-2" v-bind:class="{ active: isCurrent }">

            <div class="logo">
<router-link :to="{ name: 'Document', params: { dclIdentity: details.dclIdentity }}">
                <div class="cover-small">
                    <div class="cover-image-container">
                        <div class="cover-outer-align">
                            <div class="cover-inner-align">
                                 <i class="fal fa-file-alt fa-2x" />
                            </div>
                        </div>
                    </div>
                </div>
</router-link>
            </div>
            <div class="information w-light">
                <router-link :to="{ name: 'Document', params: { dclIdentity: details.dclIdentity }}">
                    <h5>{{ details.name }} - Version {{ details.version }}</h5>
                </router-link>
                <small>
                    {{ details.team }}
                    <router-link :to="{ name: 'Document', params: { dclIdentity: details.dclIdentity }}">
                        <br />{{ details.dclIdentity }}
                    </router-link>
               </small>
            </div>

        </div>

    </section>

</template>
<script>
    export default {
        props: ['item','current'],
        data() {
            return {
                currentDclidentity: this.current,
                selected: 0,
                details: this.item,
                user: this.$store.getters['auth/user']
            }
        },
        computed:{
            documentUrl() {
                return process.env.VUE_APP_FRONTEND + '/ledger/' + this.details.dclIdentity;
            },
            isCurrent() {
                if(this.currentDclidentity === this.details.dclIdentity) {
                    return true;
                }
                return false;
            }
        }
    }

</script>
<style>
</style>